module.exports = __webpack_public_path__ + "img/social5.42f160d2.svg";